<template>
  <article class="trainers">


    <div class="table_card">
      <div class="table_card__head">
        <v-layout row wrap fill-height>
          <v-flex xs12 lg6 class="head_contain">
            <p class="table_card__head--title">
             Categorías
            </p>
          </v-flex>
          <v-flex xs12 lg6 class="filter_options">
            <v-flex class="right mr-20">
              <button
                class="faccess_button"
                @click="active_modal_new_special_category = true"
              >
                Crear nueva categoría
              </button>
            </v-flex>
            <div
              class="buttom_reload"
              @click="findSpecialCategories()"
            >
              <img src="@/assets/img/icons/refresh-icon.svg">
            </div>
          </v-flex>
        </v-layout>
      </div>
      <div class="">
        <v-data-table
          v-model="special_categories"
          :headers="options_table.headers_table"
          :items="special_categories"
          :search="options_table.search"
          :pagination.sync="options_table.pagination"
          select-all
        >
          <template slot="headers" slot-scope="props">
            <tr>
              <th
                v-for="header in props.headers"
                :key="header.text"
                class="text-xs-left"
                :class="['column sortable', options_table.pagination.descending ? 'desc' : 'asc', header.value === options_table.pagination.sortBy ? 'active' : '']"
                @click="changeSort(header.value)">
                <v-icon small>arrow_upward</v-icon>
                {{ header.text }}
              </th>
            </tr>
          </template>
          <template slot="items" slot-scope="props">
            <tr>
              <!-- :active="props.selected" @click="props.selected = !props.selected" -->
              <td v-show="false"
                  class="text-xs-left id_new">{{ props.item.id  }}</td>
              <td
                style="cursor: pointer;"
                @click="selected_item = props.item"
              >
                <v-icon class="mr-4">{{ props.item.attributes.icon }}</v-icon>
                {{ props.item.attributes.name }}
              </td>
            </tr>
          </template>
        </v-data-table>

        <new-special-category
          @handleCancelNewSpecialCategory="cancelNewSpecialCategory"
          :active_modal="active_modal_new_special_category">
        </new-special-category>

        <edit-special-category
          v-if="active_modal_edit_special_category"
          @handleCancelEditSpecialCategory="cancelEditSpecialCategory"
          :active_edit_modal="active_modal_edit_special_category"
          :special_category = "selected_item">
        </edit-special-category>
      </div>
    </div>



    <!-- <section class="category_icons">
      <template>
        <div
          class="category_icons__container"
          v-for="(icon, index) in icons">
          <v-icon
            class="category_icons__icon">
            {{ icon }}
          </v-icon>
        </div>
      </template>
    </section> -->
  </article>
</template>

<script>
import NewSpecialCategory from './NewSpecialCategory'
import EditSpecialCategory from './EditSpecialCategory'
export default {
  data(){
    return{
      selected_item: null,
      active_modal_edit_special_category: false,
      active_modal_new_special_category: false,
      selected: 'Todos las empresas',
      special_categories:[],
      search: '',
      options_table:{
        pagination: {
          sortBy: 'name',
          rowsPerPage: 10
        },
        headers_table:[
          {
            text: 'Categoría',
            align: 'left',
            value: 'attributes.name'
          }
        ],
        filters: {
          name: [],
        },
      },
      icons:[
        'search',
        'home',
        'account_circle',
        'settings',
        'done',
        'info',
        'check_circle',
        'delete',
        'shopping_cart',
        'visibility',
        'favorite',
        'logout',
        'description',
        'favorite_border',
        'lock',
        'face',
        'schedule',
        'fingerprint',
        'language',
        'help_outline',
        'manage_accounts',
        'filter_alt',
        'thumb_up',
        'event',
        'verified',
        'dashboard',
        'calendar_today',
        'login',
        'list',
        'visibility_off',
        'check_circle outline',
        'date_range',
        'highlight_off',
        'article',
        'help',
        'question_answer',
        'paid',
        'lightbulb',
        'task_alt',
        'shopping_bag',
        'trending_up',
        'open_in new',
        'perm_identity',
        'account_balance',
        'credit_card',
        'history',
        'fact_check',
        'delete_outline',
        'report_problem',
        'assignment',
        'arrow_right alt',
        'star_rate',
        'verified_user',
        'account_balance wallet',
        'build',
        'autorenew',
        'print',
        'view_list',
        'work',
        'analytics',
        'store',
        'savings',
        'today',
        'delete_forever',
        'admin_panel settings',
        'lock_open',
        'code',
        'room',
        'grade',
        'add_shopping cart',
      ]
    }
  },
  components:{
    'new-special-category': NewSpecialCategory,
    'edit-special-category': EditSpecialCategory
  },
  mounted(){
    this.findSpecialCategories()
  },
  watch:{
    selected_item(){
      console.log(this.selected_item);
      if(this.selected_item != null){
        this.active_modal_edit_special_category = true
      }
    }
  },
  methods:{
    findSpecialCategories(){
      try {
        this.$http.get('app/special_categories/index',{
          headers:
          {"X-Device-ID" : this.getDeviceId(),
           "Authorization" : 'Bearer ' + this.getUserToken()},
        })
        .then(function(response){
          this.special_categories = response.body.data
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        }, function(response){
          if(response.body.meta != undefined && response.body.meta != null){
            if(response.body.meta.authentication_token != undefined && response.body.meta.authentication_token != null){
              this.checkToken(response.body.meta.authentication_token)
            }
          }
        })
      } catch (e) {
        alert(e.message)
      }
    },
    cancelNewSpecialCategory(event){
      this.active_modal_new_special_category = event
      this.findSpecialCategories()
    },
    cancelEditSpecialCategory(event){
      this.active_modal_edit_special_category = event
      this.selected_item = null
      this.findSpecialCategories()
    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/views/special_categories/Index.vue